module.exports = __webpack_public_path__ + "img/See-a-DEMO-popup1-th.a2b5cf3.png";